import { Alert, AlertColor } from "@mui/material";
import { SnackbarProvider, CustomContentProps, SnackbarKey } from "notistack";
import React from "react";
import { forwardRef, ReactNode } from "react";

type CloseSnackbarAction = (key?: SnackbarKey) => void;

export interface AlertProps extends CustomContentProps {
  component: React.ReactNode;
}

const ThemeResponsiveSnackbarComp = forwardRef<HTMLDivElement, AlertProps>((props, forwardedRef) => {
  const { message, variant, component, persist, action } = props;
  const closeAction = action as CloseSnackbarAction;
  return (
    <Alert
      ref={forwardedRef}
      severity={variant as AlertColor}
      variant="standard"
      onClose={persist ? () => closeAction() : undefined}
    >
      {component ? component : message}
    </Alert>
  );
});

const ThemeResponsiveSnackbar = React.memo(ThemeResponsiveSnackbarComp);

export function MuiSnackbar(props: { children: ReactNode }) {
  return (
    <SnackbarProvider
      hideIconVariant
      preventDuplicate={true}
      maxSnack={5}
      anchorOrigin={{
        horizontal: "right",
        vertical: "top",
      }}
      Components={{
        info: ThemeResponsiveSnackbar,
        success: ThemeResponsiveSnackbar,
        error: ThemeResponsiveSnackbar,
        warning: ThemeResponsiveSnackbar,
      }}
    >
      {props.children}
    </SnackbarProvider>
  );
}
